module.exports = __webpack_public_path__ + "img/norcott_t2.7b4faa0d.jpg";